import { useCallback, useRef } from 'react';

import {
  rawTrackEngagementEvent,
  rawTrackViewEvent,
} from '../../../../services/tracking/pulse';
import { pascalCaseToKebabCase } from '../../../../utils/string';
import { getSlug } from '../../../../shared/helpers/getSlug';

import type { SvpCategoryAdditional } from '@vgtv/api-client/lib/svp_category';

export const useTracking = ({
  elementType,
  pageComponentIndex,
  header,
  category,
}: {
  elementType: string;
  pageComponentIndex: number;
  header?: string;
  category?: SvpCategoryAdditional;
}) => {
  const trackingStateRef = useRef<'idle' | 'viewed'>('idle');

  const trackSliderView = useCallback(() => {
    if (trackingStateRef.current !== 'idle') {
      return;
    }

    rawTrackViewEvent({
      object: {
        id: pascalCaseToKebabCase(elementType),
        type: 'UIElement',
        name: header,
        elementType,
        position: String(pageComponentIndex),
        category: category?.title.toLowerCase(),
      },
    });

    trackingStateRef.current = 'viewed';
  }, [elementType, header, pageComponentIndex, category]);

  const trackCardClick = useCallback(
    ({ name, position }: { name: string; position: number }) => {
      if (trackingStateRef.current !== 'viewed') {
        return;
      }

      rawTrackEngagementEvent({
        intent: 'Open',
        object: {
          id: getSlug(name),
          name,
          type: 'UIElement',
          elementType: 'Card',
          position: String(position),
          category: category?.title.toLowerCase(),
        },
      });
    },
    [category]
  );

  return {
    trackSliderView,
    trackCardClick,
  };
};
